module.exports = __webpack_public_path__ + "assets/58063b748395b9f238a84ad7522c9818.mp3";